import { FC } from "react";
import { motion } from "framer-motion";
import styles from "./UserRating.module.scss";
import star from "@assets/lottie/star.json";
import { Player } from "@lottiefiles/react-lottie-player";
import classNames from "classnames";

interface IUserRatingProps {
  isReactions?: boolean;
  userRating: number;
}

export const UserRating: FC<IUserRatingProps> = (props) => {
  const { isReactions, userRating } = props;

  const roundUpToOneDecimal = (rating: number): string => {
    return (Math.ceil(rating * 10) / 10).toFixed(1);
  };

  return (
    <motion.div
      className={classNames(
        styles.ratingContainer,
        isReactions && styles.isReactions
      )}
    >
      <div className={styles.ratingImageContainer}>
        <div className={styles.ratingImage}>
          <Player
            autoplay={isReactions ? false : true}
            loop
            src={star}
            className={styles.badgeImage}
          />
        </div>
      </div>
      <p className={styles.ratingText}>{roundUpToOneDecimal(userRating)}</p>
    </motion.div>
  );
};
